import React from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as httpService from '../../services/HTTPService';
// import { redirect } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { useAuth } from '../../context/authContext';
import SpinLoader from '../spin-loader';
import { hideOverlay } from '../../utils/utils';
import SocialButtons from '../social-buttons';
import SocialAuthButtons from '../SocialAuthButtons';
import PartnersBanner from '../partners-banner';

// type GoogleLoginProp = GoogleLoginProps & {
//     className?: any
// }

function LoginForm() {
  const { t } = useTranslation();  
  const [validated, setValidated] = useState(false);
  const [visiblePass, setVisiblePass] = useState(false);
  const navigate = useNavigate();
  const { login, user, isLoading } = useAuth();
  const defaultFormData = {
    email: "",
    password: "",
    staySigned: false
  }
  let [loginForm, setLoginForm] = useState(defaultFormData);
  let [isSpinning, setIsSpinning] = useState(false);
  const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form: any = event.currentTarget;
    let loginData: any  = {...loginForm};
    const data:any = new FormData(event.currentTarget)
    //let formObject = Object.fromEntries(data.entries())
    let d = data.entries();
    for (let [key, value] of d) {
        loginData[key] = value;
        //console.log(key, value);
    }
    if(form[2].id === "staySigned") {
        const isChecked = form[2].checked ? true : false;
        loginData['staySigned'] = isChecked;
    }
    loginForm = loginData;
    setLoginForm(loginData);
    
    if (form.checkValidity() === true) {
        loginUser(loginForm);
    }
    setValidated(true);
  };

  const onLoginSuccuess = (data: any) => {
    console.log(data)
    // Google
    if(data && data.profile) {
        localStorage.setItem('googleProfile', JSON.stringify(data.profile));
        localStorage.setItem('auth-user', JSON.stringify(data.profile));
        navigate('/catalog');
    }
  }

  const loginUser = (user: any) => {
    setIsSpinning(true);
    //console.log(user);
    httpService.loginUser(JSON.stringify(user)).then((res) => {
        if(res) {
            //console.log(res);
            if(res.data) {
                let userObj = {
                    email: res.data.email,
                    token: res.data.token,
                    expiresAt: res.data.expiresAt,
                    address: res.data.address,
                    city: res.data.city,
                    company: res.data.company,
                    firstName: res.data.firstName,
                    lastName: res.data.lastName,
                    phone: res.data.phone,
                    postalCode: res.data.postalCode,
                    profession: res.data.profession
                }
                login(JSON.stringify(userObj));
                // TODO: get the token from the "data" object
                //window.location.href = "/";
                //localStorage.setItem('googleProfile', JSON.stringify(details));
                navigate('/catalog');
            }
            hidePreloader();
        }
    })
    .catch((err) => {
        console.log(err);
        let msg = t('forms.commonErrMsg');
        if(err.response && err.response.data) {
            msg = err.response.data ? err.response.data: t('forms.commonErrMsg');
            if(msg === "Invalid credentials.") {
                msg = t('forms.invalidCredentials')
            }
        }
        
        hidePreloader();
        toast.error(msg);
    })
  }

  const togglePass = () => {
    setVisiblePass(!visiblePass);
  }

    // const handleLoginUser = (loginType: string) => {
    //     if(loginType === 'Google') {
    //         const googleLoginBtn: any = document.querySelector('.google-login-btn');
    //         if(googleLoginBtn) {
    //             googleLoginBtn.click();
    //         }
    //     }
    // }

    // const GoogleLoginComonent = (props: GoogleLoginProps) => {
    //     return (
    //         <GoogleLogin {...props} /> 
    //     )
    // }

    const staySignedOnChange = (e: any) => {
        if(e.target.checked) {
            localStorage.setItem('staySigned', 'true');
        }
    }

    const navigateTo = (location: string) => {
        navigate(location);
    }

    const hidePreloader = () => {
        hideOverlay();
        setIsSpinning(false);
    }

  return (
    <div>
        <ToastContainer position="top-center"
 />
        <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3">
                <Form.Group as={Col} md="12" controlId="email">
                    <Form.Label>{t('forms.email')}*</Form.Label>
                    <Form.Control 
                        type="email"
                        name="email"
                        required
                    />
                    <Form.Control.Feedback type="invalid">
                     {t('forms.validEmailError')}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="12" controlId="validationCustom07" className='pass-group'>
                    <Form.Label>{t('forms.password')}*</Form.Label>
                    <Form.Control type={visiblePass ? "text" : "password"} name="password" required />
                    <span className='showPassBtn' onClick={togglePass}></span>
                    <Form.Control.Feedback type="invalid">
                        {t('forms.requiredFieldError', { field: t('forms.password')})}
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="staySigned">
                    <Form.Check
                        label={t('forms.rememberMe')}
                        name="staySigned"
                        onChange={staySignedOnChange}
                    />
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="validationCustom05">
                    <div className='align-right'>
                        {/* <a className="forgot-link" href="/forgotpass">{t('forms.forgotPass')}</a> */}
                        <span className="forgot-link cursor-pointer" onClick={() => navigateTo('/forgotpass')} >{t('forms.forgotPass')}</span>
                    </div>
                </Form.Group>
                <Form.Group as={Col} xs="6" controlId="validationCustom08">
                    <div className='align-center btn-out btn-white margin-0'>
                        <Button type="submit">{t('forms.signin')}</Button>
                    </div>
                </Form.Group>
                <Form.Group as={Col} xs="6" controlId="validationCustom09">
                    <div className='align-center btn-out margin-0'>
                        <Button onClick={() => navigateTo('/register')} variant="light">{t('forms.register')}</Button>
                    </div>
                </Form.Group>
            </Row>
            <Row className="mb-3 login-sep">
                <div className='align-center'>
                    <span>{t('forms.loginWith')}</span>
                </div>
            </Row>
            <SocialAuthButtons onSuccess={onLoginSuccuess} />
            <Row className="mb-3 login-sep">
                <PartnersBanner />
            </Row>
        </Form>
        {isSpinning ? (
            <SpinLoader />
        ) : null}
    </div>
  );
}

export default LoginForm;